var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeam(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 73,
    viewBox: "0 0 70 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.8832 67.7061H50.1743C49.9499 67.724 49.7404 67.8259 49.5877 67.9914C49.435 68.1568 49.3502 68.3737 49.3502 68.5989C49.3502 68.8241 49.435 69.041 49.5877 69.2065C49.7404 69.3719 49.9499 69.4738 50.1743 69.4918H53.8832C54.1076 69.4738 54.3171 69.3719 54.4698 69.2065C54.6225 69.041 54.7073 68.8241 54.7073 68.5989C54.7073 68.3737 54.6225 68.1568 54.4698 67.9914C54.3171 67.8259 54.1076 67.724 53.8832 67.7061ZM27.0974 67.7061H23.3886C23.1642 67.724 22.9547 67.8259 22.802 67.9914C22.6493 68.1568 22.5645 68.3737 22.5645 68.5989C22.5645 68.8241 22.6493 69.041 22.802 69.2065C22.9547 69.3719 23.1642 69.4738 23.3886 69.4918H27.0974C27.3219 69.4738 27.5313 69.3719 27.6841 69.2065C27.8368 69.041 27.9216 68.8241 27.9216 68.5989C27.9216 68.3737 27.8368 68.1568 27.6841 67.9914C27.5313 67.8259 27.3219 67.724 27.0974 67.7061ZM47.5645 67.7061H29.7073C29.4705 67.7061 29.2434 67.8001 29.076 67.9676C28.9085 68.135 28.8145 68.3621 28.8145 68.5989C28.8145 68.8357 28.9085 69.0628 29.076 69.2303C29.2434 69.3977 29.4705 69.4918 29.7073 69.4918H36.8234V70.3846H33.2788C33.042 70.3846 32.8148 70.4787 32.6474 70.6461C32.48 70.8136 32.3859 71.0407 32.3859 71.2775C32.3859 71.5143 32.48 71.7414 32.6474 71.9088C32.8148 72.0763 33.042 72.1703 33.2788 72.1703H44.4395C44.6763 72.1703 44.9034 72.0763 45.0708 71.9088C45.2383 71.7414 45.3323 71.5143 45.3323 71.2775C45.3323 71.0407 45.2383 70.8136 45.0708 70.6461C44.9034 70.4787 44.6763 70.3846 44.4395 70.3846H40.4484V69.4918H47.5645C47.8013 69.4918 48.0284 69.3977 48.1958 69.2303C48.3633 69.0628 48.4573 68.8357 48.4573 68.5989C48.4573 68.3621 48.3633 68.135 48.1958 67.9676C48.0284 67.8001 47.8013 67.7061 47.5645 67.7061Z",
    fill: "#1E83E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7952 6.70801C39.9035 6.75299 40.0196 6.77617 40.1368 6.77624C40.2541 6.77631 40.3702 6.75327 40.4786 6.70843C40.5869 6.66358 40.6854 6.59782 40.7683 6.5149C40.8512 6.43198 40.917 6.33354 40.9618 6.22518L42.4084 2.73593C42.4533 2.62761 42.4764 2.51151 42.4765 2.39425C42.4765 2.27698 42.4534 2.16086 42.4086 2.05251C42.3638 1.94415 42.298 1.84569 42.2152 1.76274C42.1323 1.6798 42.0339 1.61399 41.9255 1.56907C41.8172 1.52416 41.7011 1.50102 41.5838 1.50098C41.4666 1.50093 41.3505 1.52399 41.2421 1.56882C41.1337 1.61366 41.0353 1.6794 40.9523 1.76228C40.8694 1.84517 40.8036 1.94358 40.7587 2.0519L39.3121 5.54115C39.2215 5.75995 39.2215 6.00578 39.3121 6.2246C39.4026 6.44342 39.5764 6.6173 39.7952 6.70801Z",
    fill: "#1E83E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9201 11.092C47.0375 11.0922 47.1539 11.069 47.2624 11.024C47.3709 10.979 47.4694 10.9129 47.5522 10.8295L50.2286 8.14551C50.3119 8.0626 50.3779 7.96407 50.423 7.85557C50.4681 7.74706 50.4914 7.63072 50.4914 7.51322C50.4915 7.39572 50.4683 7.27936 50.4233 7.17082C50.3783 7.06229 50.3123 6.96371 50.2291 6.88073C50.1459 6.79776 50.0471 6.73203 49.9385 6.68731C49.8298 6.64258 49.7134 6.61975 49.5959 6.62012C49.4784 6.62049 49.3621 6.64405 49.2537 6.68945C49.1453 6.73485 49.047 6.8012 48.9643 6.8847L46.2879 9.56872C46.1633 9.69368 46.0786 9.85277 46.0443 10.0259C46.0101 10.199 46.0279 10.3784 46.0955 10.5414C46.1632 10.7043 46.2776 10.8436 46.4243 10.9416C46.5711 11.0396 46.7436 11.092 46.9201 11.092Z",
    fill: "#2D4356"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5416 17.6342C51.6605 17.6341 51.7782 17.6102 51.8878 17.564L55.3934 16.0872C55.6112 15.995 55.7836 15.8201 55.8727 15.601C55.9617 15.3818 55.9602 15.1362 55.8684 14.9182C55.7765 14.7002 55.6019 14.5275 55.3829 14.4381C55.1639 14.3487 54.9183 14.3499 54.7002 14.4414L51.1946 15.9182C51.0046 15.9983 50.8483 16.1416 50.752 16.3239C50.6557 16.5061 50.6254 16.7161 50.6662 16.9181C50.7071 17.1202 50.8166 17.3019 50.9761 17.4324C51.1357 17.5629 51.3355 17.6342 51.5416 17.6342ZM23.5967 6.22518C23.6874 6.44395 23.8613 6.61772 24.0801 6.70826C24.2989 6.79881 24.5448 6.79872 24.7635 6.70801C24.9823 6.61731 25.1561 6.44341 25.2466 6.22458C25.3371 6.00575 25.3371 5.75992 25.2464 5.54115L23.7998 2.0519C23.7091 1.83314 23.5352 1.65937 23.3164 1.56882C23.0976 1.47827 22.8517 1.47836 22.633 1.56907C22.4142 1.65978 22.2404 1.83368 22.1499 2.05251C22.0593 2.27133 22.0594 2.51717 22.1501 2.73593L23.5967 6.22518Z",
    fill: "#1E83E6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0061 10.83C17.0888 10.9135 17.1871 10.9798 17.2955 11.0252C17.4039 11.0706 17.5201 11.0942 17.6376 11.0945C17.7552 11.0949 17.8716 11.0721 17.9802 11.0274C18.0889 10.9826 18.1877 10.9169 18.2709 10.8339C18.3541 10.751 18.4201 10.6524 18.4651 10.5438C18.5101 10.4353 18.5333 10.3189 18.5332 10.2014C18.5332 10.0839 18.5099 9.9676 18.4648 9.8591C18.4197 9.7506 18.3536 9.65207 18.2704 9.56916L15.594 6.88514C15.4266 6.71845 15.1999 6.62491 14.9637 6.625C14.7275 6.62509 14.5009 6.71881 14.3336 6.88562C14.1664 7.05243 14.072 7.27874 14.0713 7.51497C14.0706 7.7512 14.1635 7.97809 14.3297 8.14595L17.0061 10.83Z",
    fill: "#2D4356"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16511 16.0883L12.6707 17.5651C12.8889 17.657 13.1348 17.6585 13.3541 17.5692C13.5734 17.4799 13.7483 17.3071 13.8402 17.0888C13.9321 16.8706 13.9336 16.6248 13.8443 16.4054C13.7549 16.1861 13.5821 16.0113 13.3639 15.9193L9.85831 14.4425C9.64014 14.351 9.39459 14.3499 9.17557 14.4393C8.95655 14.5287 8.78196 14.7013 8.69013 14.9194C8.5983 15.1374 8.59675 15.3829 8.6858 15.6021C8.77486 15.8212 8.94725 15.9961 9.16512 16.0883L9.16511 16.0883Z",
    fill: "#1E83E6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.42545 29.871L2.08929 28.9982L1.67009 28.7607L1.24375 29.7384H1.22991L0.796875 28.7674L0.370535 29.0121L1.02723 29.8643V29.8782L0 29.7456V30.2206L1.03393 30.088V30.1018L0.370535 30.9536L0.768304 31.2054L1.22277 30.2206H1.23661L1.6558 31.1982L2.09598 30.9469L1.42545 30.1085V30.0947L2.47991 30.2206V29.7456L1.42545 29.8848V29.871Z",
    fill: "#1E83E6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3856 0.772321L25.0034 1.26295L25.2329 1.40759L25.4945 0.840625H25.5021L25.7436 1.40357L25.9972 1.25893L25.611 0.775893V0.767857L26.2182 0.840625V0.566964L25.611 0.647322V0.639286L25.9932 0.136607L25.7521 0L25.5066 0.562946H25.4985L25.249 0.00357138L25.0034 0.144643L25.3816 0.635268V0.643304L24.79 0.566964V0.840625L25.3856 0.764286V0.772321Z",
    fill: "#1E83E6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M69.915 12.7745V12.3088L68.8806 12.4459V12.4321L69.5315 11.5758L69.1204 11.3428L68.7025 12.3017H68.6887L68.2641 11.3495L67.8458 11.5896L68.49 12.4254V12.4392L67.4824 12.3088V12.7745L68.4967 12.6446V12.6584L67.8458 13.4941L68.2364 13.741L68.682 12.7745H68.6954L69.1065 13.7338L69.5382 13.4874L68.8806 12.6651V12.6513L69.915 12.7745Z",
    fill: "#1E83E6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9343 12.2708L55.4959 11.5319L55.141 11.3311L54.7808 12.1583H54.7687L54.4026 11.3369L54.0415 11.544L54.5973 12.265V12.2766L53.7285 12.1645V12.5663L54.6031 12.4538V12.4659L54.0415 13.1869L54.3785 13.3998L54.7629 12.5663H54.7745L55.1294 13.3936L55.5017 13.1811L54.9343 12.4717V12.4596L55.8263 12.5663V12.1645L54.9343 12.2824V12.2708Z",
    fill: "#1E83E6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3994 34.158V17.7793H56.1045V33.486",
    stroke: "#2D4356",
    strokeWidth: 1.385,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5531 21.4756L36.7021 26.6832",
    stroke: "#2D4356",
    strokeWidth: 1.385,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5371 20.7197L49.5529 21.4757L48.797 23.4915",
    stroke: "#2D4356",
    strokeWidth: 1.385,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5068 20.8877H29.4783",
    stroke: "#2D4356",
    strokeWidth: 1.385,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5068 24.415H29.4783",
    stroke: "#2D4356",
    strokeWidth: 1.385,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5068 28.0273H29.4783",
    stroke: "#2D4356",
    strokeWidth: 1.385,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2981 30.2109H36.1143V34.5786H38.2981V30.2109Z",
    fill: "#1E83E6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2453 28.6152H40.0615V34.5788H42.2453V28.6152Z",
    fill: "#1E83E6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1936 27.0186H44.0098V34.5779H46.1936V27.0186Z",
    fill: "#1E83E6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1409 25.3389H47.957V34.4941H50.1409V25.3389Z",
    fill: "#1E83E6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7558 55.6599C64.7558 56.9198 63.9158 58.0957 62.7399 58.5157C60.7241 59.2716 58.3723 59.6076 55.9365 59.6076C53.5007 59.6076 51.1489 59.1876 49.133 58.5157C47.9571 58.0957 47.1172 56.9198 47.1172 55.6599C47.1172 50.2843 51.0649 48.7725 55.9365 48.7725C60.8081 48.7725 64.7558 50.2843 64.7558 55.6599Z",
    fill: "white",
    stroke: "#2D4356",
    strokeWidth: 1.385,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3877 59.0198V56.584",
    stroke: "#2D4356",
    strokeWidth: 1.385,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4004 59.0198V56.584",
    stroke: "#2D4356",
    strokeWidth: 1.385,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3037 41.6333C60.3037 44.2371 58.2878 46.3369 55.852 46.3369C53.4162 46.3369 51.4004 44.2371 51.4004 41.6333C51.4004 39.0295 53.4162 36.9297 55.852 36.9297C58.2878 36.9297 60.3037 39.0295 60.3037 41.6333Z",
    fill: "#1E83E6",
    stroke: "#2D4356",
    strokeWidth: 1.385,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3037 41.6333C60.3037 42.2213 60.2197 42.7252 60.0517 43.2292C59.4637 44.993 57.7839 46.3369 55.936 46.3369C53.5002 46.3369 51.4844 44.2371 51.4844 41.6333C51.4844 41.5493 51.4844 41.5493 51.4844 41.4653C51.5684 39.0295 53.4162 37.0137 55.768 36.9297C55.852 36.9297 55.852 36.9297 55.936 36.9297C56.692 36.9297 57.4479 37.1817 58.1198 37.5176C59.3797 38.3576 60.3037 39.8695 60.3037 41.6333Z",
    fill: "white",
    stroke: "#2D4356",
    strokeWidth: 1.385,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5928 50.7881L55.0967 51.376L54.5088 54.5678L55.9367 55.7437L57.3646 54.5678L56.6926 51.376L57.1966 50.7881",
    fill: "#1E83E6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0359 37.5176C57.7839 38.6096 57.1119 39.6175 56.272 40.3734C55.3481 41.1294 54.1722 41.6333 52.8283 41.6333C52.4083 41.6333 51.9043 41.5493 51.4844 41.4653C51.5684 39.0295 53.4162 37.0137 55.768 36.9297C55.852 36.9297 55.852 36.9297 55.936 36.9297C56.692 36.9297 57.4479 37.1817 58.0359 37.5176Z",
    fill: "#2D4356",
    stroke: "#2D4356",
    strokeWidth: 1.385,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3042 41.6333C60.3042 42.2213 60.2202 42.7252 60.0522 43.2292C58.3724 42.8932 57.0285 41.8013 56.2725 40.3734C55.8526 39.6175 55.6846 38.7775 55.6846 37.9376C55.6846 37.6016 55.6846 37.2657 55.7686 36.9297C55.8526 36.9297 55.8526 36.9297 55.9365 36.9297C56.6925 36.9297 57.4484 37.1817 58.1204 37.5176C59.3803 38.3576 60.3042 39.8695 60.3042 41.6333Z",
    fill: "#2D4356",
    stroke: "#2D4356",
    strokeWidth: 1.385,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4023 55.6599C30.4023 56.9198 29.5623 58.0957 28.3864 58.5157C26.3706 59.2716 24.0188 59.6076 21.583 59.6076C19.1472 59.6076 16.7954 59.1876 14.7795 58.5157C13.5196 58.0957 12.6797 56.9198 12.6797 55.6599C12.6797 50.2843 16.6274 48.7725 21.499 48.7725C26.4546 48.7725 30.4023 50.2843 30.4023 55.6599Z",
    fill: "white",
    stroke: "#2D4356",
    strokeWidth: 1.385,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0342 59.0198V56.584",
    stroke: "#2D4356",
    strokeWidth: 1.385,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0469 59.0198V56.584",
    stroke: "#2D4356",
    strokeWidth: 1.385,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9501 41.6333C25.9501 44.2371 23.9343 46.3369 21.4985 46.3369C19.0627 46.3369 17.1309 44.2371 17.1309 41.6333C17.1309 39.0295 19.1467 36.9297 21.5825 36.9297C24.0183 36.9297 25.9501 39.0295 25.9501 41.6333Z",
    fill: "#1E83E6",
    stroke: "#2D4356",
    strokeWidth: 1.385,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9501 41.6333C25.9501 42.2213 25.8662 42.7252 25.6982 43.2292C25.1102 44.993 23.4304 46.3369 21.5825 46.3369C19.1467 46.3369 17.1309 44.2371 17.1309 41.6333C17.1309 41.5493 17.1309 41.5493 17.1309 41.4653C17.2149 39.0295 19.0627 37.0137 21.4145 36.9297C21.4985 36.9297 21.4985 36.9297 21.5825 36.9297C22.3384 36.9297 23.0944 37.1817 23.7663 37.5176C25.0262 38.3576 25.9501 39.8695 25.9501 41.6333Z",
    fill: "white",
    stroke: "#2D4356",
    strokeWidth: 1.385,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2393 50.7881L20.7432 51.376L20.0713 54.5678L21.4992 55.7437L22.9271 54.5678L22.3391 51.376L22.8431 50.7881",
    fill: "#1E83E6"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6823 37.5176C23.4304 38.6096 22.7584 39.6175 21.9185 40.3734C20.9945 41.1294 19.8186 41.6333 18.4748 41.6333C18.0548 41.6333 17.5508 41.5493 17.1309 41.4653C17.2149 39.0295 19.0627 37.0137 21.4145 36.9297C21.4985 36.9297 21.4985 36.9297 21.5825 36.9297C22.3384 36.9297 23.0944 37.1817 23.6823 37.5176Z",
    fill: "#2D4356",
    stroke: "#2D4356",
    strokeWidth: 1.385,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9507 41.6333C25.9507 42.2213 25.8667 42.7252 25.6987 43.2292C24.0188 42.8932 22.6749 41.8013 21.919 40.3734C21.499 39.6175 21.3311 38.7775 21.3311 37.9376C21.3311 37.6016 21.3311 37.2657 21.415 36.9297C21.499 36.9297 21.499 36.9297 21.583 36.9297C22.339 36.9297 23.0949 37.1817 23.7669 37.5176C25.0268 38.3576 25.9507 39.8695 25.9507 41.6333Z",
    fill: "#2D4356",
    stroke: "#2D4356",
    strokeWidth: 1.385,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5531 60.7841C49.5531 62.38 48.5452 63.8078 47.0333 64.3118C44.5975 65.1517 41.7417 65.6557 38.7179 65.6557C35.6942 65.6557 32.8384 65.1517 30.4026 64.3118C28.8907 63.8078 27.8828 62.38 27.8828 60.7841C27.8828 54.2326 32.7544 52.3848 38.7179 52.3848C44.6815 52.3848 49.5531 54.2326 49.5531 60.7841Z",
    fill: "white",
    stroke: "#2D4356",
    strokeWidth: 1.385,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1777 64.9837V61.96",
    stroke: "#2D4356",
    strokeWidth: 1.385,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2588 64.9837V61.96",
    stroke: "#2D4356",
    strokeWidth: 1.385,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7183 49.3606C41.6872 49.3606 44.0939 46.8034 44.0939 43.649C44.0939 40.4946 41.6872 37.9375 38.7183 37.9375C35.7495 37.9375 33.3428 40.4946 33.3428 43.649C33.3428 46.8034 35.7495 49.3606 38.7183 49.3606Z",
    fill: "#1E83E6",
    stroke: "#2D4356",
    strokeWidth: 1.385,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0939 43.649C44.0939 44.321 44.0099 44.9929 43.7579 45.5809C43.002 47.7647 40.9862 49.3606 38.7183 49.3606C35.7786 49.3606 33.3428 46.8408 33.3428 43.649C33.3428 43.565 33.3428 43.4811 33.3428 43.4811C33.4268 40.4573 35.6946 38.1055 38.5504 37.9375C38.6343 37.9375 38.6343 37.9375 38.7183 37.9375C39.6423 37.9375 40.5662 38.1895 41.3221 38.6934C43.002 39.6174 44.0939 41.5492 44.0939 43.649Z",
    fill: "white",
    stroke: "#2D4356",
    strokeWidth: 1.385,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1221 54.8203L37.71 55.5763L36.9541 59.4399L38.718 60.8678L40.4818 59.4399L39.7259 55.5763L40.3138 54.8203",
    fill: "#1E83E6"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3221 38.6934C40.9862 40.0373 40.1462 41.2972 39.1383 42.1372C37.9624 43.0611 36.5345 43.649 34.9387 43.649C34.3507 43.649 33.8467 43.565 33.2588 43.4811C33.3428 40.4573 35.6106 38.1055 38.4664 37.9375C38.5504 37.9375 38.5504 37.9375 38.6344 37.9375C39.6423 37.9375 40.5662 38.1895 41.3221 38.6934Z",
    fill: "#2D4356",
    stroke: "#2D4356",
    strokeWidth: 1.385,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0934 43.649C44.0934 44.321 44.0094 44.9929 43.7574 45.5809C41.7416 45.1609 40.0617 43.901 39.1378 42.1372C38.6338 41.2132 38.3818 40.2053 38.3818 39.1134C38.3818 38.6934 38.3818 38.2735 38.4658 37.9375C38.5498 37.9375 38.5498 37.9375 38.6338 37.9375C39.5577 37.9375 40.4817 38.1895 41.2376 38.6934C43.0015 39.6174 44.0934 41.5492 44.0934 43.649Z",
    fill: "#2D4356",
    stroke: "#2D4356",
    strokeWidth: 1.385,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/Team.2b55e211248c0574577a19340e100f3f.svg";
export { ForwardRef as ReactComponent };